const emailVerified = {
  "v-card-title": "Huy! Algo salió mal",
  "v-card-text":
    "Para continuar, debe haber verificado su correo electrónico, verifique su bandeja de entrada, ya le enviamos un correo electrónico"
};
export default emailVerified;
